import * as Sentry from '@sentry/react'

export interface ErrorMetadata {
  componentName?: string
  userId?: string
  additionalData?: Record<string, unknown>
  [key: string]: unknown
}

export class ErrorTrackingService {
  private static instance: ErrorTrackingService
  private isProduction: boolean

  private constructor() {
    this.isProduction = import.meta.env.PROD
  }

  public static getInstance(): ErrorTrackingService {
    if (!ErrorTrackingService.instance) {
      ErrorTrackingService.instance = new ErrorTrackingService()
    }
    return ErrorTrackingService.instance
  }

  public captureError(error: Error, metadata?: ErrorMetadata): void {
    // Use Sentry for error tracking in both dev and prod
    Sentry.withScope((scope) => {
      if (metadata?.componentName) {
        scope.setTag('component', metadata.componentName)
      }
      if (metadata?.userId) {
        scope.setTag('userId', metadata.userId)
      }
      if (metadata) {
        scope.setExtras(metadata)
      }
      Sentry.captureException(error)
    })

    // Also log to console for development
    if (this.isProduction) {
      console.error('Error:', error, 'Metadata:', metadata)
    } else {
      console.warn('Dev Error:', error, 'Metadata:', metadata)
    }
  }

  public setUser(userId: string): void {
    Sentry.setUser({ id: userId })
  }

  public clearUser(): void {
    Sentry.setUser(null)
  }
}
